import React from "react";
import styled from "@emotion/styled";
import {useViewController} from "data/services/locator";
import {Bindings} from "data/constants/bindings";
import {ModalError} from "views/components/modals/ModalError/modalError.component";
import {IHOCMainController} from "views/components/HOCMain/HOCMain.controller";
import {Preloader} from "views/components/Preloader/preloader.component";
import {observer} from "mobx-react";
import {ModalTerms} from "views/components/modals/ModalTerms/modalTerms.component";
import mainBg from "assets/img/mainBg.jpg";
import {IS_SHOW_SECRET_PAGE} from "data/constants/secretPage";
import {SecretPage} from "./SecretPage";
import {redirectByBrowserLanguage} from "data/utils";

const Main = styled.main`
	width: 100%;
	height: 100%;
	position: relative;
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	background: url(${mainBg});
	background-size: cover;
`;

interface IProps {
	children: React.ReactNode;
}

export const HOCMain: React.FC<IProps> = observer(({children}) => {
	const {isLoadingUser} = useViewController<IHOCMainController>(Bindings.HOCMainController);
	redirectByBrowserLanguage();

	if (isLoadingUser) {
		return <Preloader fixed />;
	}

	return IS_SHOW_SECRET_PAGE ? (
		<SecretPage />
	) : (
		<Main>
			<React.Fragment>{children}</React.Fragment>
			<ModalTerms />
			<ModalError />
		</Main>
	);
});
